import { createAction, props } from '@ngrx/store';
import { ICalendarioMaquina } from 'src/app/usuarios/models/IMaquinaFecha';
import { IMaquinaEstadoResponse } from '../models/maquina';

export const loadMaquinas = createAction(
  'Load Maquinas',
  props<{ usuarioId: number; empresaId: number, fechaDesde:any }>()
);

export const loadedMaquinasError = createAction(
  'Load Maquinas Error',
  props<{ error: any }>()
);

export const loadedMaquinasSuccess = createAction(
  'Load Maquinas Success',
  props<{ maquinas: IMaquinaEstadoResponse; calendario: ICalendarioMaquina[] }>()
);

export const cleanMaquinas = createAction('Clean Maquinas');
